export const POPUP_ID = 'popup-id';
export const POPUP_ACTIVE = 'popup-active';
export const POPUP_CONTENT = 'popup-content';
export const POPUP_CLICK_CALLBACK = 'popup-click-callback';
